import { useEffect, useState } from "react";

/**
 * Returns a debounced value that only updates after `delay` ms of no further
 * changes to `value`. Shared by Entities and AuditLog search inputs.
 */
export function useDebounced<T>(value: T, delay: number): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(id);
  }, [value, delay]);
  return debounced;
}
